import React from 'react';
import { useIntl } from 'react-intl';
import { FAQPageJsonLd } from 'next-seo';
import Typography from '@nubank/nuds-web/components/Typography/Typography';
import Link from '@nubank/nuds-web/components/Link/Link';

import Section from 'components/structure/Section';
import Block from 'components/structure/Block/Block';
import CollapsePanel from 'components/ui/CollapsePanel/CollapsePanel';
import { maybeFormatMessage } from 'utils/i18nUtils';
import sanitizer from 'utils/sanitizer';

import { StyledList, StyledListItem } from './styles/List';

const questionKeys = [
  'WHO_HAS',
  'HOW_TO_PAY',
  'GRACE_DAYS',
  'MAX_DUE_DATE',
  'INTEREST_RATE',
  'PORTABILITY',
];

function SectionFAQ() {
  const intl = useIntl();

  return (
    <Section
      id="faq"
      backgroundColor="white.dark"
    >
      <Block justifyContent="center" blockWidth="100%">
        <Typography
          variant="title"
          color="black"
          colorVariant="default"
          gutterBottom={4}
          intlKey="LENDING.FAQ.TITLE"
        />
        <StyledList>
          {questionKeys.map(key => (
            <StyledListItem key={key}>
              <CollapsePanel
                title={maybeFormatMessage(intl, 'LENDING.FAQ', `${key}.QUESTION`)}
                body={maybeFormatMessage(intl, 'LENDING.FAQ', `${key}.ANSWER`)}
              />
            </StyledListItem>
          ))}
        </StyledList>
        <Typography
          variant="paragraph2"
          intlKey="LENDING.FAQ.MORE_QUESTIONS"
        />
        <Typography
          variant="paragraph2"
          gutterBottom={4}
          intlKey="LENDING.FAQ.MORE_ANSWERS"
          intlValues={{
            a: (...txt) => (
              <Link
                href="/perguntas"
                color="primary"
                typographyProps={{
                  variant: 'paragraph2',
                }}
              >
                {txt}
              </Link>
            ),
          }}
        />
      </Block>
      <FAQPageJsonLd mainEntity={questionKeys.map(key => ({
        questionName: sanitizer.forJSON(maybeFormatMessage(intl, 'LENDING.FAQ', `${key}.QUESTION`)),
        acceptedAnswerText: sanitizer.forJSON(maybeFormatMessage(intl, 'LENDING.FAQ', `${key}.ANSWER`)),
      }))}
      />
    </Section>
  );
}

export default React.memo(SectionFAQ);
